import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Container } from '../styles/styled';
import Logo from '../images/logo.svg';
import { Linkedin, Mail, Phone } from 'lucide-react';

const FooterWrapper = styled.footer`
  background-color: #f5f5f5;
  padding: 60px 0 30px;
  margin-top: 80px;

  @media (max-width: 768px) {
    padding: 40px 0 20px;
    margin-top: 60px;
  }
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 60px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const BrandColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  

  span {
    font-size: 28px;
    font-weight: 700;
    color: #000;

    @media (max-width: 768px) {
      font-size: 24px;
    }
  }
`;

const Motto = styled.p`
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  max-width: 350px;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

const MenuColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  h3 {
    font-size: 16px;
    font-weight: 700;
    color: #000;
    margin-bottom: 5px;

    @media (max-width: 768px) {
      font-size: 15px;
    }
  }

  a {
    color: #666;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s ease;

    &:hover {
      color: #002dff;
    }

    @media (max-width: 768px) {
      font-size: 13px;
    }
  }
`;

const ContactColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  h3 {
    font-size: 16px;
    font-weight: 700;
    color: #000;
    margin-bottom: 5px;

    @media (max-width: 768px) {
      font-size: 15px;
    }
  }
`;

const ContactItem = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;

  &:hover {
    color: #002dff;
  }

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    color: #666;
  }

  @media (max-width: 768px) {
    font-size: 13px;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;

  &:hover {
    color: #002dff;

    svg {
      color: #002dff;
    }
  }

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    color: #666;
  }

  @media (max-width: 768px) {
    font-size: 13px;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

const FooterBottom = styled.div`
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
  text-align: center;
  color: #666;
  font-size: 14px;

  @media (max-width: 768px) {
    margin-top: 30px;
    font-size: 13px;
  }
`;

const Footer = () => {
  const { t } = useTranslation('common');

  return (
    <FooterWrapper>
      <Container>
        <FooterContent>
          {/* Brand Column */}
          <BrandColumn>
            <LogoContainer>
              <img src={Logo} alt="Hurrlink Logo" />
       
            </LogoContainer>
            <Motto>{t('header.shortDesc')}</Motto>
          </BrandColumn>

          {/* Menu Column */}
          <MenuColumn>
            <h3>{t('footer.menu')}</h3>
            <a href="#what-we-do">{t('whatWeDo')}</a>
            <a href="#why-hurrlink">{t('whyHurrlink')}</a>
            <a href="#for-banks">{t('forBanks')}</a>
            <a href="#contact">{t('contact')}</a>
          </MenuColumn>

          {/* Contact Column */}
          <ContactColumn>
            <h3>{t('footer.contact')}</h3>
            <ContactItem href="mailto:admin@hurrlink.com">
              <Mail />
              admin@hurrlink.com
            </ContactItem>
            <ContactItem href="tel:+998507791911">
              <Phone />
              +998 507791911
            </ContactItem>
            <SocialLink
              href="https://www.linkedin.com/company/hurrlink"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Linkedin />
              LinkedIn
            </SocialLink>
          </ContactColumn>
        </FooterContent>

        <FooterBottom>
          <span>{t('footer.copyright')}</span>
        </FooterBottom>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;
